import { Form } from '../../assets/js/components/form';

const contactForm = new Form('.contact-form', 'g-modal-contact');
contactForm.init();
